export default {
  subscribe: "Subscribe",
  subscribeText:
    "Stay updated with the latest courses and offers from SkillSynergy.",
  submit: "Send",
  sending: "Sending...",
  success: "Subscribed!",
  failed: "Failed!",
};
